import { render, staticRenderFns } from "./PersonAvailabilities.vue?vue&type=template&id=9c67e66c"
import script from "./PersonAvailabilities.vue?vue&type=script&lang=js"
export * from "./PersonAvailabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports